import React, { useEffect } from "react";

const baseUrl = "https://booking.svalbardadventures.com";

const LANG_ID = {
  en: 2,
  no: 5,
};

/**
 * A great component that displays a shop name!
 *
 * @param {object} props
 * @param {'en'|'no'} props.lang The language to use for the redirect.
 * @param {'accommodation'|'conference'} [props.type='accommodation'] The type of booking to redirect to.
 * @returns {JSX.Element}
 */
export const RedirectToBookVisit = ({ lang, type = "accommodation" }) => {
  useEffect(() => {
    handleRedirect(lang, type);
  }, [lang]);

  return null;
};

const handleRedirect = (lang, type) => {
  const redirectUrl = new URL(type, baseUrl);
  redirectUrl.searchParams.set("langid", LANG_ID[lang]);

  window.location.replace(redirectUrl);
};
